import { Stack, Typography } from "@mui/material";
import { LaunchAIContentCard } from "./create-ai-content-carousel";

import type { FC } from "react";

export const EmptyState: FC = () => (
  <Stack gap={4} textAlign="center" maxWidth="md" mx="auto" alignItems="center" my={4}>
    <Stack gap={2} direction="row" alignItems="center">
      <svg xmlns="http://www.w3.org/2000/svg" width="50px" viewBox="0 0 24 24">
        <defs>
          <linearGradient id="Gradient1">
            <stop className="stop1" offset="8.45%" />
            <stop className="stop2" offset="106.53%" />
          </linearGradient>
        </defs>
        <style>
          {`
            .stop1 {
                stop-color: #00B6EF;
            }
            .stop2 {
                stop-color: #DF1C8E;
            }
            `}
        </style>
        <path
          d="M9 13h10l-3.45-4.5l-2.3 3l-1.55-2zm-6 8q-.825 0-1.412-.587T1 19V6h2v13h17v2zm4-4q-.825 0-1.412-.587T5 15V4q0-.825.588-1.412T7 2h5l2 2h7q.825 0 1.413.588T23 6v9q0 .825-.587 1.413T21 17zm0-2h14V6h-7.825l-2-2H7zm0 0V4z"
          fill="url(#Gradient1)"
        />
      </svg>
      <Typography fontWeight={700} variant="body1">
        You haven’t saved any content yet
      </Typography>
    </Stack>
    <Stack gap={2}>
      <Typography fontWeight={400} variant="body2">
        When you create content with ChangeEngine, you’ll be able to save it here to reuse at any
        time. Use the &quot;Save&quot; button on the edit screen.
      </Typography>
      <Typography fontWeight={400} variant="body2" color="text.secondary">
        (Excludes Communications, which you can find on the home page or in &quot;Sent
        Communications&quot;)
      </Typography>
    </Stack>
    <Typography fontWeight={700} variant="body2">
      Create New Content
    </Typography>

    <Stack gap={2}>
      <Stack direction="row" gap={2} justifyContent="center">
        <LaunchAIContentCard
          title="Video"
          image="https://images.changeengine.com/video.png"
          format="Video"
        />
        <LaunchAIContentCard
          title="Manager One-Pager"
          image="https://images.changeengine.com/onepager2.png"
          format="Manager One-Pager"
        />
        <LaunchAIContentCard
          title="FAQ"
          image="https://images.changeengine.com/faq2.png"
          format="FAQ"
        />
      </Stack>
      <Stack direction="row" gap={2} justifyContent="center">
        <LaunchAIContentCard
          title="Guide"
          image="https://images.changeengine.com/guide.png"
          format="Guide"
        />
        <LaunchAIContentCard
          title="Square Logo"
          image="https://images.changeengine.com/squarelogo2.png"
          format="Square Logo"
        />
        <LaunchAIContentCard
          title="Landscape Logo"
          image="https://images.changeengine.com/landscapelogo2.png"
          format="Landscape Logo"
        />
        <LaunchAIContentCard
          title="Video Call Background"
          image="https://images.changeengine.com/zoombg2.png"
          format="Video Call Background"
        />
      </Stack>
      <Stack direction="row" gap={2} justifyContent="center">
        <LaunchAIContentCard
          title="TV Display"
          image="https://images.changeengine.com/tvbg2.png"
          format="TV Display"
        />
        <LaunchAIContentCard
          title="Poster"
          image="https://images.changeengine.com/poster2.png"
          format="Poster"
        />
        <LaunchAIContentCard
          title="Certificate"
          image="https://images.changeengine.com/certificate2.png"
          format="Certificate"
        />
        <LaunchAIContentCard
          title="Horizontal Banner"
          image="https://images.changeengine.com/horizontalbanner.png"
          format="Horizontal Banner"
        />
      </Stack>
    </Stack>
  </Stack>
);
